module.exports = __webpack_public_path__ + "static/media/pessocial3.2cab9c20.png";